import './scroll_indicator.less';

import React from 'react';

import {
  SCROLL_INDICATOR_LIGHT,
  SCROLL_INDICATOR_DARK
} from 'zoomforth_codesbane_editor/exterior_editor/sidebar/menu_item_editor/menu_item_subpage.jsx';

import ScrollIndicatorUi from './scroll_indicator.ui.jsx';

const ScrollIndicator = ({
  isMobile,
  submenuItems,
  currentSubpage,
  isAnchorActiveById,
  onScrollToSubmenuItem
})=> {
  const scrollIndicatorColorClass = {
    [SCROLL_INDICATOR_LIGHT]: 'light',
    [SCROLL_INDICATOR_DARK]: 'dark'
  }[currentSubpage.scrollIndicatorColor];

  return (
    <ScrollIndicatorUi
      isAnchorActiveById={isAnchorActiveById}
      currentSubpage={currentSubpage}
      submenuItems={submenuItems}
      isMobile={isMobile}
      scrollIndicatorColorClass={scrollIndicatorColorClass}
      onScrollToSubmenuItem={onScrollToSubmenuItem}
    />
  );
};

export default ScrollIndicator;
